import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'name',
  standalone: false
})
export class NamePipe implements PipeTransform {
  transform(name: string | undefined): string {
    if (!name) {
      return '';
    }

    return name.replace(/\b[\w`]+\b/g, name => name.charAt(0).toUpperCase() + name.substring(1).toLowerCase()).replace(/'s\b/gi, "'s");
  }
}
